import injectionCode from '../../../preview/standard-checkout'

const type = 'standard'
const path = '/standard/react-node/client/src/'
const name = 'App.jsx'

export { type, path, name, injectionCode }
